/**
 * @file コンポーネント：フル動画ページ評価ボタン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledButton = styled.button`
    display: inline-flex;
    align-items: flex-start;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #929496;
    font-size: 20px;
    line-height: 20px;
`;

export const StyledButtonCount = styled.span`
    margin-left: 2px;
    font-size: 12px;
    line-height: 12px;
`;
